import type { IconNode } from '../types';

/**
 * @name clef-treble
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuNTg2IDIxLjQxNGEyIDIgMCAwIDAgMy4zNzgtMS43OTFMMTEuMDM2IDQuMzc3YTIgMiAwIDEgMSAzLjM3OCAxLjAzN0MxMi40MTQgNy40MTQgNyA4IDcgMTNhNSA1IDAgMCAwIDUgNSA1IDQgMCAwIDAgNS00IDMgMyAwIDAgMC0zLTMgMyAyIDAgMCAwLTMgMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/clef-treble
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ClefTreble: IconNode = [
  [
    'path',
    {
      d: 'M10.586 21.414a2 2 0 0 0 3.378-1.791L11.036 4.377a2 2 0 1 1 3.378 1.037C12.414 7.414 7 8 7 13a5 5 0 0 0 5 5 5 4 0 0 0 5-4 3 3 0 0 0-3-3 3 2 0 0 0-3 2',
    },
  ],
];

export default ClefTreble;
